import { useRef } from 'react';

import ListItem from '@mui/material/ListItem';

import { MenuItem } from './components/MenuItem';
import { ProfileInfo } from './components/ProfileInfo';
import * as Styled from './UserMenu.style';

import Icon from '../BusinessEntityNav/components/MenuItemIcon';
import useAnchorElement from '../hooks/useAnchorElement';
import { COLOR_MODE } from '../hooks/useColorPalette';
import MENU_SECTIONS from './config';

function UserMenu() {
  const menuRef = useRef(null);
  const buttonRef = useRef(null);
  const { anchorElement, onButtonClick, onMenuClose } = useAnchorElement(menuRef, buttonRef);
  const open = Boolean(anchorElement);

  return (
    <>
      <Styled.Button
        ref={buttonRef}
        aria-controls="profile-menu"
        aria-haspopup="true"
        aria-label="profile menu"
        onClick={onButtonClick}
        role="button"
        // todo: add is-open class
        sx={(theme) => (open ? ({
          backgroundColor: theme.palette.focus90.main,
          '& img.active': {
            opacity: 1
          }
        }) : ({
          backgroundColor: theme.palette.focus10.main
        }))}
      >
        <Icon
          colorMode={COLOR_MODE.ACTIVE_WHITE}
          src="user-outline.svg"
        />
      </Styled.Button>

      <Styled.Menu
        anchorEl={anchorElement}
        id="profile-menu"
        onClose={onMenuClose}
        onBlur={onMenuClose}
        open={open}
        ref={menuRef}
      >
        <ListItem sx={{ padding: 0 }}>
          <ProfileInfo />
        </ListItem>

        {MENU_SECTIONS.map((section, idx) => (
          <MenuItem
            index={idx}
            key={section.type === 'divider' ? 'divider' : section.title}
            onClick={onMenuClose}
            section={section}
          />
        ))}

      </Styled.Menu>
    </>
  );
}

export default UserMenu;
